import styled from 'styled-components';

export const Wrapper = styled.div`
  display: inline-block;
  margin: 0px;
`;
Wrapper.displayName = 'Tooltip_Wrapper';

export const TriggerWrapper = styled.div`
  display: inline;
`;
TriggerWrapper.displayName = 'Tooltip_TriggerWrapper';

export const TriggerText = styled.div`
  display: inline;
  border-bottom: dashed 1px ${({ theme }) => theme.colors.charcoal};
`;
TriggerText.displayName = 'Tooltip_TriggerText';

export const TriggerIconActive = styled.div`
  display: none;
  ${Wrapper}:hover &, ${Wrapper}:focus & {
    display: inline;
  }
`;
TriggerIconActive.displayName = 'Tooltip_TriggerIconActive';

export const TriggerIcon = styled.div`
  display: inline;
  ${Wrapper}:hover &, ${Wrapper}:focus & {
    display: none;
  }
`;
TriggerIcon.displayName = 'Tooltip_TriggerIcon';

export const Box = styled.div`
  visibility: hidden;
  border: 1px solid ${({ theme }) => theme.colors.silver};
  max-width: 400px;
  padding: ${({ theme }) => theme.fUnit(12)};
  padding-top: ${({ theme }) => theme.fUnit(8)};
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 99998;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.2);

  ${Wrapper}:hover &, ${Wrapper}:focus & {
    visibility: visible;
  }
`;
Box.displayName = 'Tooltip_Box';

export const Arrow = styled.div`
  height: 0.4rem;
  &::before {
    content: ' ';
    position: absolute;
    border: 1px solid ${({ theme }) => theme.colors.silver};
    border-bottom-color: transparent;
    border-right-color: transparent;
    width: 10px;
    height: 10px;
    z-index: 99999;
    background-color: ${({ theme }) => theme.colors.white};
  }

  ${Box}[data-popper-placement^='bottom'] & {
    bottom: 100%;
    &::before {
      transform: translate(-5px, 0px) rotate(45deg);
    }
  }

  ${Box}[data-popper-placement^='top'] & {
    top: 100%;
    &::before {
      transform: translate(-5px, -4px) rotate(225deg);
      box-shadow: -1px -1px 1px rgba(0, 0, 0, 0.2);
    }
  }
`;

Arrow.displayName = 'Tooltip_Arrow';
